import * as React from 'react';
import { useCallback } from 'react';

import { Bem } from '../../service/Bem/Bem';

import './LimitedColorPicker.css';

export interface LimitedColorPickerProps {
    colors: string[];
    onColorSelect: (color: string) => void;
}

const BLOCK = 'limited-color-picker';

export class LimitedColorPicker extends React.PureComponent<LimitedColorPickerProps> {
    private static ColorItem = React.memo(({ color, click }: { color: string; click: (color: string) => void }) => {
        const style = {
            backgroundColor: color
        };

        const onClick = useCallback(() => click(color), [color]);

        return (
            <div
                className={Bem.cls(BLOCK, 'color-item', {
                    white: color.toLowerCase() === '#ffffff'
                })}
                style={style}
                onClick={onClick}
            />
        );
    });

    render(): React.ReactNode {
        const { colors, onColorSelect } = this.props;

        return (
            <div className={BLOCK}>
                {colors.map((color: string) => (
                    <LimitedColorPicker.ColorItem key={color} click={onColorSelect} color={color} />
                ))}
            </div>
        );
    }
}
